<template>
  <div id="app" class="flex-column space-between">
    <div class="app-viewport">
      <Header v-if="!$layout.isMobile"/>
      <NavbarDesktop v-if="!$layout.isMobile"/>
      <NavbarMobile v-else/>
      <router-view class="view"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HookManager from "@/code/axios";
import NavbarDesktop from "@/components/NavbarDesktop";
import NavbarMobile from "@/components/NavbarMobile";

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    NavbarDesktop,
    NavbarMobile
  },
  created: function() {
    //const brand = this.$t("brand");
    //document.title = `${brand} - Аренда выделенного сервера`;

    HookManager.on('wrong_creds', this.loginRedirect);
  },
  methods: {
    loginRedirect: function() {
      const next = btoa(JSON.stringify({
        path: this.$route.path,
        query: this.$route.query,
      }));
      this.$router.push({name: "Login", query: {next: next}});
    },
  },
}
</script>

<style scoped lang="scss">
  #app {
    width: 100vw;
    min-height: 100vh;

    .app-viewport {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

</style>
